import globalAxios from 'axios';
import { B as BaseAPI, D as DUMMY_BASE_URL, s as setBearerAuthToObject, b as setSearchParams, c as serializeDataIfNeeded, t as toPathString, o as operationServerMap, d as createRequestFunction, e as BASE_PATH } from '../common-BuhUSHAi.js';

/* tslint:disable */
/* eslint-disable */
/**
 * BizWeb Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * ReturnPolicyApi - axios parameter creator
 * @export
 */
const ReturnPolicyApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary  (Auth roles: Orders)
         * @param {ReturnPolicyEntityType} [entityType] Σε ποια οντότητα αναφέρεται μια γραμμή πολιτικής επιστροφών.
         * @param {number} [entityId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get: async (entityType, entityId, options = {}) => {
            const localVarPath = `/v1/ReturnPolicy/Get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (entityType !== undefined) {
                localVarQueryParameter['entityType'] = entityType;
            }
            if (entityId !== undefined) {
                localVarQueryParameter['entityId'] = entityId;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Orders)
         * @param {ReturnPolicyToken} [ReturnPolicyToken]
         * @param {ReturnPolicyEntityType} [entityType] Σε ποια οντότητα αναφέρεται μια γραμμή πολιτικής επιστροφών.
         * @param {number} [entityId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        put: async (ReturnPolicyToken, entityType, entityId, options = {}) => {
            const localVarPath = `/v1/ReturnPolicy/Put`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (entityType !== undefined) {
                localVarQueryParameter['entityType'] = entityType;
            }
            if (entityId !== undefined) {
                localVarQueryParameter['entityId'] = entityId;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(ReturnPolicyToken, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * ReturnPolicyApi - functional programming interface
 * @export
 */
const ReturnPolicyApiFp = function (configuration) {
    const localVarAxiosParamCreator = ReturnPolicyApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary  (Auth roles: Orders)
         * @param {ReturnPolicyEntityType} [entityType] Σε ποια οντότητα αναφέρεται μια γραμμή πολιτικής επιστροφών.
         * @param {number} [entityId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async get(entityType, entityId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.get(entityType, entityId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReturnPolicyApi.get']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Orders)
         * @param {ReturnPolicyToken} [ReturnPolicyToken]
         * @param {ReturnPolicyEntityType} [entityType] Σε ποια οντότητα αναφέρεται μια γραμμή πολιτικής επιστροφών.
         * @param {number} [entityId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async put(ReturnPolicyToken, entityType, entityId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.put(ReturnPolicyToken, entityType, entityId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReturnPolicyApi.put']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * ReturnPolicyApi - factory interface
 * @export
 */
const ReturnPolicyApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ReturnPolicyApiFp(configuration);
    return {
        /**
         *
         * @summary  (Auth roles: Orders)
         * @param {ReturnPolicyEntityType} [entityType] Σε ποια οντότητα αναφέρεται μια γραμμή πολιτικής επιστροφών.
         * @param {number} [entityId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get(entityType, entityId, options) {
            return localVarFp.get(entityType, entityId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Orders)
         * @param {ReturnPolicyToken} [ReturnPolicyToken]
         * @param {ReturnPolicyEntityType} [entityType] Σε ποια οντότητα αναφέρεται μια γραμμή πολιτικής επιστροφών.
         * @param {number} [entityId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        put(ReturnPolicyToken, entityType, entityId, options) {
            return localVarFp.put(ReturnPolicyToken, entityType, entityId, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * ReturnPolicyApi - object-oriented interface
 * @export
 * @class ReturnPolicyApi
 * @extends {BaseAPI}
 */
class ReturnPolicyApi extends BaseAPI {
    /**
     *
     * @summary  (Auth roles: Orders)
     * @param {ReturnPolicyEntityType} [entityType] Σε ποια οντότητα αναφέρεται μια γραμμή πολιτικής επιστροφών.
     * @param {number} [entityId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReturnPolicyApi
     */
    get(entityType, entityId, options) {
        return ReturnPolicyApiFp(this.configuration).get(entityType, entityId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Orders)
     * @param {ReturnPolicyToken} [ReturnPolicyToken]
     * @param {ReturnPolicyEntityType} [entityType] Σε ποια οντότητα αναφέρεται μια γραμμή πολιτικής επιστροφών.
     * @param {number} [entityId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReturnPolicyApi
     */
    put(ReturnPolicyToken, entityType, entityId, options) {
        return ReturnPolicyApiFp(this.configuration).put(ReturnPolicyToken, entityType, entityId, options).then((request) => request(this.axios, this.basePath));
    }
}

export { ReturnPolicyApi, ReturnPolicyApiAxiosParamCreator, ReturnPolicyApiFactory, ReturnPolicyApiFp };
//# sourceMappingURL=return-policy-api.js.map
